import { render, staticRenderFns } from "./EditInvestor.vue?vue&type=template&id=8b747524&"
import script from "./EditInvestor.vue?vue&type=script&lang=js&"
export * from "./EditInvestor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports